/* eslint-disable no-underscore-dangle */
import {put,call,takeLatest} from 'redux-saga/effects';
import { CHANGE_PASSWORD } from '../action/constant';
import {  confrimPasswordError, confrimPasswordSuccess } from '../action/confirmPassword';
import request from '../utils/request';


function* changePassSaga(action){
  const token = localStorage.getItem('token');
  const data = JSON.parse(localStorage.getItem('adminData'));
  const url = `Admin/change?id=${data._id}`;
  try{
  const response = yield call(request,url,{
    method:"PUT",
    headers:{
        Accept:'application/json',
        Authorization:`VMS-2.0${token}`
    },
    data:action.data
  });
  yield put(confrimPasswordSuccess(response.data));
  }
  catch(err){
  yield put(confrimPasswordError(err.response.data));
  }
}
export default function* watcherPassSaga(){
  yield takeLatest(CHANGE_PASSWORD.PENDING,changePassSaga);
}
